import { apiBaseUrl } from "@/store/api/constants/baseURL"
import axios from "axios"

const GET_SCHEME_SALES_DATA_URL = apiBaseUrl + 'Scheme/Sap/fetch-sales-data/'

class SchemeStatusService {

  // GET SAP Schemes Sales Data
  getSapSchemeSalesData(cus_number,dateInfoId,product) {
    const token = localStorage.getItem("serviceToken") || localStorage.getItem("token");
    return axios.get(GET_SCHEME_SALES_DATA_URL + cus_number+'||'+dateInfoId+'||'+product, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      withCredentials: true
    })
  }

}

export default new SchemeStatusService()
